import { useBypassTeamsStore } from "@/stores/bypassTeamsStore";
import TeamLogo from "./team-logo";
import { Button } from "@heroui/button";
import { Link } from "react-router-dom";
import { X } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { menuIsBlockingContent } from "@/stores/MenuStore";

export default function FreeTeams() {
    const { t } = useTranslation();
    const teamsBypass = useBypassTeamsStore((state) => state.teamsBypass);
    const [closed, setClosed] = useState(() => localStorage.getItem('freeTeamsBannerClosed') === 'true');
    if (!teamsBypass.length || menuIsBlockingContent()) return null;

    const handleClose = () => {
        localStorage.setItem('freeTeamsBannerClosed', 'true');
        setClosed(true);
    };

    return (
        !closed &&
        <div className='border border-default-200 fixed bottom-28 right-5 z-30 bg-default-100 bg-opacity-95 rounded-lg p-4 shadow-md shadow-default-100'>
            <X onClick={handleClose} size={20} className='cursor-pointer absolute top-2 right-2 text-default-500' />
            <span className='mb-3 block text-default-600'>
                {t('free_teams.free_teams_1')}
            </span>
            <div className='flex gap-3'>
                {teamsBypass.map((team) => (
                    <Link to={`/team/${team.team_id}`} key={team.team_id}>
                        <Button variant="solid" color='default'
                            key={team.team_id} className='flex items-center gap-2 p-2 rounded-lg' startContent={<TeamLogo teamId={team.team_id} size={20} />}>
                            {team.name}
                        </Button>
                    </Link>
                ))}
            </div>
            <Link to="/plans" className="w-full">
                <Button variant="solid" color='primary' className='gap-2 p-2 rounded-lg mt-3 w-full'>
                    {t('free_teams.free_teams_2')}
                </Button>
            </Link>
            <span className='text-default-500 text-sm mt-2 block'>
                {t('free_teams.free_teams_3')}
            </span>
        </div>
    );
}

